import { render, staticRenderFns } from "./tutorials-installation.vue?vue&type=template&id=bb91059c&scoped=true"
import script from "./tutorials-installation.vue?vue&type=script&lang=js"
export * from "./tutorials-installation.vue?vue&type=script&lang=js"
import style0 from "./tutorials-installation.vue?vue&type=style&index=0&id=bb91059c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb91059c",
  null
  
)

export default component.exports